<template>
  <div>
    <!-- Page Banner -->
    <section class="page-banner bgs-cover overlay pt-50 ban-h mob-ban" style="background-image: url(/assets/images/banner-cloud.jpg)">
      <div class="container">
        <div class="banner-inner">
          <h1 class="page-title2 clr-000">{{ $t('services.cloud.subtitle') }} <br><span>{{ $t('services.cloud.subtitleSpan.part1') }}<br>{{ $t('services.cloud.subtitleSpan.part2') }}</span></h1>
        </div>
      </div>
    </section>

    <!-- Services Description -->
    <section>
      <div class="container ser-des">
        <h1 class="mt-80">{{ $t('services.cloud.title') }}</h1>
        <p class="lh2 mob-ban-title mt-30 mb-80">
          {{ $t('services.cloud.description') }}
        </p>
      </div>
    </section>

    <!-- Key Features Section -->
    <section class="about-section-six py-60 rpb-90 bg-bg1">
      <div class="container">
        <div class="row">
          <div class="col-md-4 features1 disp-desk">
            <div class="mb-35">
              <h2 class="col-section3">{{ $t('services.cloud.keyFeatures.title') }}</h2>
            </div>
          </div>
          <div class="col-md-4 disp-mob">
            <div class="mb-35">
              <h2 class="col-section3">{{ $t('services.cloud.keyFeatures.title') }}</h2>
            </div>
          </div>
          <div class="col-md-8">
            <div class="about-six-content mr-0 rmr-0 wow fadeInLeft delay-0-2s pl-50">
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.cloud.keyFeatures.items.zeroDowntime.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.cloud.keyFeatures.items.zeroDowntime.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.cloud.keyFeatures.items.scalableArchitecture.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.cloud.keyFeatures.items.scalableArchitecture.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.cloud.keyFeatures.items.securityFirst.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.cloud.keyFeatures.items.securityFirst.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.cloud.keyFeatures.items.multiCloudEnablement.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.cloud.keyFeatures.items.multiCloudEnablement.description') }}</p>
                </div>
              </div>
              <div class="service-item-six">
                <div class="service-content df-it">
                  <h5>{{ $t('services.cloud.keyFeatures.items.costOptimization.title') }}</h5>
                  <div class="bar"></div>
                  <p>{{ $t('services.cloud.keyFeatures.items.costOptimization.description') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section (Desktop) -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100 bg-bg2 disp-desk" id="BankingExpertise">
      <div class="container">
        <div class="d-flex justify-content-between">
          <div class="col-md-7 d-flex">
            <div class="col-md-6 mt-50">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/cloud-provider.png" />
                    <h5>{{ $t('services.cloud.benefits.items.cloudAgnostic.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.cloudAgnostic.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/cloud-expert.png" />
                    <h5>{{ $t('services.cloud.benefits.items.certifiedExperts.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.certifiedExperts.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/partnership-cloud.png" />
                    <h5>{{ $t('services.cloud.benefits.items.endToEndPartnership.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.endToEndPartnership.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/performance-c.png" />
                    <h5>{{ $t('services.cloud.benefits.items.performanceCompliance.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.performanceCompliance.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-5 section-title1 pt-80 mb-35 pl-100">
            <h2>{{ $t('services.cloud.benefits.title') }}</h2>
            <p>{{ $t('services.cloud.benefits.description') }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Benefits Section (Mobile) -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100 bg-bg2 disp-mob" id="BankingExpertise">
      <div class="container">
        <div class="col-md-5 section-title1 mb-20">
          <h2>{{ $t('services.cloud.benefits.title') }}</h2>
          <p>{{ $t('services.cloud.benefits.description') }}</p>
        </div>
        <div class="d-flex justify-content-between">
          <div class="col-md-7">
            <div class="col-md-6 mt-20">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/cloud-provider.png" />
                    <h5>{{ $t('services.cloud.benefits.items.cloudAgnostic.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.cloudAgnostic.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/cloud-expert.png" />
                    <h5>{{ $t('services.cloud.benefits.items.certifiedExperts.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.certifiedExperts.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-6">
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/partnership-cloud.png" />
                    <h5>{{ $t('services.cloud.benefits.items.endToEndPartnership.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.endToEndPartnership.description') }}</p>
                  </li>
                </ul>
              </div>
              <div class="feature-item wow fadeInUp delay-0-2s exp-b exp-b1 col-xl-12 col-md-12">
                <ul class="feature-icon ta-c">
                  <li>
                    <img src="/assets/images/icon/performance-c.png" />
                    <h5>{{ $t('services.cloud.benefits.items.performanceCompliance.title') }}</h5>
                    <p class="bank-exp">{{ $t('services.cloud.benefits.items.performanceCompliance.description') }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Call to Action -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 back-end" id="BackendDevelopment" style="background-image: url(/assets/images/lets_build.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 mt-40">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w dclr-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="lets">
                    <h2>{{ $t('services.cloud.callToAction.title') }}</h2>
                    <button>{{ $t('services.cloud.callToAction.button') }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <!-- Empty column for spacing -->
          </div>
        </div>
      </div>
    </section>

    <!-- Services Offered Title -->
    <div>
      <h1 class="hiw mt-50">{{ $t('services.cloud.servicesOffered.title') }}</h1>
    </div>

    <!-- Cloud Migration Section -->
    <section class="about-section-eight pt-60 rpt-35 pb-60 rpb-100" id="cloudmigration">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/cloud-mig.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.cloud.servicesOffered.cloudMigration.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.cloud.servicesOffered.cloudMigration.description') }}</p>
                <li v-for="(feature, index) in $tm('services.cloud.servicesOffered.cloudMigration.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- DevOps Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="devops">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.cloud.servicesOffered.devopsService.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.cloud.servicesOffered.devopsService.description') }}</p>
                <li v-for="(feature, index) in $tm('services.cloud.servicesOffered.devopsService.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/devops-opalina.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PaaS Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100" id="paas">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/paas.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.cloud.servicesOffered.paas.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.cloud.servicesOffered.paas.description') }}</p>
                <li v-for="(feature, index) in $tm('services.cloud.servicesOffered.paas.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Cloud Monitoring Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="cloudmonitoring">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.cloud.servicesOffered.monitoring.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three mt-15">
                <p>{{ $t('services.cloud.servicesOffered.monitoring.description') }}</p>
                <li v-for="(feature, index) in $tm('services.cloud.servicesOffered.monitoring.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/cloud-monitoring.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Cloud Security Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100" id="cloudsecurity">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/cloud-security.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.cloud.servicesOffered.security.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.cloud.servicesOffered.security.description') }}</p>
                <li v-for="(feature, index) in $tm('services.cloud.servicesOffered.security.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Multi-Cloud Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1" id="multicloud">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order1">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title2">
                    <h2>{{ $t('services.cloud.servicesOffered.multiCloud.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <p>{{ $t('services.cloud.servicesOffered.multiCloud.description') }}</p>
                <li v-for="(feature, index) in $tm('services.cloud.servicesOffered.multiCloud.features')" :key="index">
                  <p>{{ feature }}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order">
            <div class="about-eight-images aei rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/multicloud.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesCloud'
}
</script>